// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';
import { QAReadabilityService } from '@client/app/blocks/service/qa-readability/qareadability.service';

@Pipe({
    name: 'translateReadability',
    standalone: false,
})
export class TranslateReadabilityPipe implements PipeTransform {
    constructor (private qaReadabilityService: QAReadabilityService) {}

    transform (score: any, readabilityType?: string): string {
        if (!score) {
            return '';
        }

        return this.qaReadabilityService.getTranslationScore(score, readabilityType || '');
    }
}
